import '@patsnap-ui/icon/assets/solid/NavSearch.svg';
import '@patsnap-ui/icon/assets/solid/IntegrateHistory.svg';
import '@patsnap-ui/icon/assets/solid/CoreProductsInsights.svg';
import '@patsnap-ui/icon/assets/solid/CoreProductsLandscape.svg';
import '@patsnap-ui/icon/assets/solid/ChartChunk.svg';
import '@patsnap-ui/icon/assets/solid/ContentFormatingGrid3.svg';
import '@patsnap-ui/icon/assets/solid/EmailAlerts.svg';
import '@patsnap-ui/icon/assets/solid/HistoryRecord.svg';
import '@patsnap-ui/icon/assets/solid/NavWorkspace.svg';
import '@patsnap-ui/icon/assets/solid/GroupedAssignee.svg';
import '@patsnap-ui/icon/assets/solid/Cas.svg';
import '@patsnap-ui/icon/assets/solid/polls.svg';
import '@patsnap-ui/icon/assets/solid/Telecom.svg';
import { CAS2_URI } from 'library-@/config/apiConfig';
import type { PartitionItem } from '@patsnap-biz/master-nav/src/NavService';
import { SLD } from '@patsnap-utils/biz';

export interface NavItem extends PartitionItem {
    pathKey?: SLD;
    url?: string;
    routeName?: string;
    fullPath?: string;
    children?: NavItem[];
}

export type ToolNavList = Array<NavItem | string>;

export const SEARCH_NAV_CONFIG = {
    simpleSearch: {
        'routeName': 'AdvanceSimple',
        'url': '/search/input/simple'
    },
    fieldSearch: {
        'routeName': 'AdvanceField',
        'url': '/search/input/field'
    },
    expertSearch: {
        'routeName': 'AdvanceProject',
        'url': '/search/input/field/project'
    },
    bulkSearch: {
        'routeName': 'AdvanceBulk',
        'url': '/search/input/bulk'
    },
    semanticSearch: {
        'routeName': 'AdvanceSemantic',
        'url': '/search/input/semantic'
    },
    imageSearch: {
        'routeName': 'AdvanceImage',
        'url': '/search/input/image'
    },
    divergent: {
        'routeName': 'AdvanceExpand',
        'url': '/search/input/expand'
    },
    classification: {
        'routeName': 'AdvanceClassification',
        'url': '/search/input/classification'
    },
    legalSearch: {
        'routeName': 'AdvanceLegal',
        'url': '/search/input/legal'
    },
    legalCase: {
        'routeName': 'AdvanceLegalCase',
        'url': '/search/input/legal-case'
    },
    npl: {
        'routeName': 'AdvanceNpl',
        'url': '/search/input/npl'
    },
};

export const LOCAL_ROUTENAME_MODULES = [
    'AdvanceSimple',
    'AdvanceField',
    'AdvanceBulk',
    'AdvanceProject',
    'AdvanceSemantic',
    'AdvanceImage',
    'AdvanceExpand',
    'AdvanceClassification',
    'AdvanceLegal',
    'AdvanceLegalCase',
    'AdvanceNpl',
    'historyQuerySavedSearchesView'
];

export const DEFAULT_CLOSE_NAV_MODULES = [
    'PatentResult',
    'ImageResult',
    'CaseResult'
];

export const TOOL_NAV_LIST: ToolNavList = [
    'sidebar_tools',
    {
        key: 'analyze',
        icon: 'SolidPolls',
        label: 'commonNav.analyze',
        children: [
            { key: 'charts', /* icon: 'SolidChartChunk', */ pathKey: SLD.DASHBOARD, url: 'charts?from_site=analytics' },
            { key: 'report', pathKey: SLD.DASHBOARD, url: 'report?from_site=analytics' },
            { key: 'dashboard', /* icon: 'SolidContentFormatingGrid3', */ pathKey: SLD.DASHBOARD, url: 'dashboards?from_site=analytics' },
            { key: 'landscape', /* icon: 'SolidCoreProductsLandscape', */ pathKey: SLD.ANALYTICS, url: 'landscape#/home' },
        ],
    },
    { key: 'workspace', icon: 'SolidNavWorkspace', pathKey: SLD.WORKSPACE, url: '' },
    { key: 'alert', icon: 'SolidEmailAlerts', pathKey: SLD.HOME, url: 'alert' },
    { key: 'history', icon: 'SolidHistoryRecord', pathKey: SLD.HOME, url: 'history/#/analytics/0/1?from_site=analytics' },
    { key: 'assigneegrouping', icon: 'SolidGroupedAssignee', pathKey: SLD.HOME, url: 'gname' },
];

export const CAS_SEARCH: NavItem[] = [
    {
        key: 'cas_search',
        icon: 'SolidCas',
        label: 'searchMenus.cas_search',
        children: [
            {
                key: 'structure_search',
                label: 'searchMenus.structure',
                routeName: 'ChemicalStructure',
                fullPath: `${CAS2_URI}/#/search/structure`
            },
            {
                key: 'markush_search',
                label: 'searchMenus.markush',
                routeName: 'ChemicalMarkush',
                fullPath: `${CAS2_URI}/#/search/markush?type=markush&mode=drw`
            },
            {
                key: 'substances_search',
                label: 'searchMenus.substances',
                routeName: 'ChemicalText',
                fullPath: `${CAS2_URI}/#/search/text`
            },
        ],
    },
];

export const TELECOM_SEARCH: NavItem[] = [
    {
        key: 'telecom_search',
        icon: 'SolidTelecom',
        label: 'commonNav.telecom',
        children: [
            {
                key: 'tdoc_search',
                label: 'searchMenus.telecom_tdoc',
                pathKey: SLD.ANALYTICS,
                url: 'telecom',
            }
        ],
    },

];

export const PATENT_SEARCH_NAV_LIST: NavItem[] = [
    {
        key: 'search',
        icon: 'SolidNavSearch',
        label: 'commonNav.patent',
        childLimit: 6,
        limitLabel: 'searchMenus.moreSearch',
        children: []
    },
]

export const HISTORY_QUERY_NAV_LIST: NavItem[] = [
    {
        key: 'my_searches',
        icon: 'SolidIntegrateHistory',
        label: 'historyQuery.historyQueries',
        children: [
            { key: 'searchHistory', pathKey: SLD.HOME, url: 'history/#/analytics/1/1?from_site=analytics' },
            { key: 'savedSearches', label: 'commonNav.savedSearches', routeName: 'historyQuerySavedSearchesView', url: '/my/history#/history-query/saved/1' },
            {
                key: 'savedCASSearches',
                label: 'commonNav.savedCASSearches',
                fullPath: `${CAS2_URI}/#/saved-searches`,
            },
        ]
    },
]

export const AI_LAB_LIST: NavItem[] = [
    {
        key: 'aiLab',
        slot: 'aiLab',
        pathKey: SLD.ANALYTICS,
        url: 'ai-lab',
    },
];
